module.exports = __webpack_public_path__ + "img/lancamento-lemonde-mobile.bc45be0e.webp";